<template>
  <div class="fast-clients--container">
    <div class="fast-clients--row mrg-t-20" v-for="(item, index) in data" :key="index">
      <div v-if="item.is_double" class="alert alert-sm alert-danger text-center mrg-b-10">
        Данный клиент уже есть в списке и не будет добавлен при сохранении
      </div>
      <div>
        <label for="">Клиент</label>
        <search-client
          v-model="item.clients"
          :selected="item.clients"
          :reset="reset"
        ></search-client>
      </div>
      <div>
        <client-select-modification
          v-if="item.clients"
          v-model="item.client_modification_id"
          :clientsModificationsRelations="item.clients.clientsModificationsRelations"
        ></client-select-modification>
      </div>
      <div>
        <div 
          v-if="item.clients && (+item.clients.is_unwanted === 1 || item.clients.is_unwanted === true)" 
          class="text-small text-center text-danger"
        >
          Нежелательный клиент!
        </div>
      </div>

      <div 
        v-if="item !== '' && item.add_field !== null && fullConfig.company_config && fullConfig.company_config.add_field == 0" 
        class="new-fast--addfield-line mrg-t-10"
      >
        <div 
          v-if="item.add_field !== '' && item.add_field !== null && fullConfig.company_config && fullConfig.company_config.add_field == 0" 
          class="new-fast--addfield-line-text"
        >
          <div class="title text-bold">Дополнительное поле</div>
          <div class="text ">{{item.add_field}}</div>
        </div>
      </div>

      <div 
        v-if="fullConfig.company_config && fullConfig.company_config.add_field == 1" 
        class="new-fast--addfield-line mrg-t-10"
      >
        <div 
          v-if="fullConfig.company_config && fullConfig.company_config.add_field == 1" 
          class="new-fast--addfield-line-form"
        >
          <!-- <div class="title text-bold">Дополнительное поле</div> -->
          <div v-if="fullConfig.company_config && fullConfig.company_config.add_field_type == 0" class="input-block mrg-t-5 mrg-b-5i">
            <label>
              <span class="text-bold">{{fullConfig.company_config.add_field_name}} (Доп.поле)</span>
              <span v-if="fullConfig.company_config.add_field_required == 1" class="req">*</span>
            </label>
            <input type="text" v-model="item.add_field">
          </div>
          <div v-if="fullConfig.company_config && fullConfig.company_config.add_field_type == 1" class="input-block mrg-t-10 mrg-b-5i">
            <label>
              {{fullConfig.company_config.add_field_name}}
              <span v-if="fullConfig.company_config.add_field_required == 1" class="req">*</span>
            </label>
            <textarea v-model="item.add_field"></textarea>
          </div>
        </div>
      </div> 

      <div v-show="item.comment" class="new-fast--comments-line mrg-t-10">
        <div class="title text-bold">Комментарий клиента</div>
        <div  class="new-fast--comment-client mrg-t-5 mrg-b-5">
          <div class="text">{{item.comment}}</div>
        </div>
      </div>

      <!-- cancel_reason -->
      <div class="fast-clients--cancel-reason mrg-t-10" v-if="+item.is_canceled === 1">
        <div class="input-block mrg-t-10 mrg-b-5i">
            <label>
              Причина отмены записи (необязательное поле)
            </label>
            <textarea rows="1" v-model="item.cancel_reason"></textarea>
          </div>
      </div>

      <div class="client-line--flex mrg-t-10">
        <div class="action-item">
          <div>
            <a 
              class="tel btn-badge btn-success" 
              v-if="item.clients" 
              :href="'tel:+' +item.clients.number"
            >
              <f-awesome icon="phone"></f-awesome>
              Позвонить
            </a>
          </div>
        </div>
        <div class="action-item">
          <div>
            <a 
              class="tel btn-badge btn-success" 
              v-if="item.clients" 
              @click="clickManualSms(item.clients.number)"
              
              target="_blank"
            >
              <f-awesome icon="sms"></f-awesome>
              СМС
            </a>
          </div>
        </div>
        <div class="action-item">
          <div>
            <a class="tel btn-badge btn-success" v-if="item.clients" :href="whatsAppEndpoint(item.clients.number)" target="_blank">
              WhatsApp
            </a>
          </div>
        </div>
        <div class="action-item">
          <div>
            <a class="tel btn-badge btn-purple" v-if="item.clients" :href="'viber://chat?number=%2B' +item.clients.number" target="_blank">
              Viber
            </a>
          </div>
        </div>
        <div class="action-item">
          <div>
            <div 
              class="info btn-badge btn-orange" 
              v-if="item.clients" @click="showInfoClientPopup(item.clients.id)"
            >
              <f-awesome icon="user-edit"></f-awesome>
              Открыть/Изменить клиента
            </div>
          </div>
        </div>
        <div class="action-item">
          <div>
            <div 
              class="info btn-badge btn-outline-info" 
              v-if="item.clients" @click="copyText(item.clients.number)"
            >
              <f-awesome icon="copy"></f-awesome>
              Копировать номер
            </div>
          </div>
        </div>
        <div class="action-item">
          <div>
            <div @click="showNotificationHistoryPopup(index)" class="info btn-badge btn-outline-info">
              <f-awesome icon="history"></f-awesome>
              История уведомлений
            </div>
          </div>
        </div>
      </div>

      <div class="fast-clients--status mrg-t-15">
        <div v-if="item.clients" class="status mrg-r-10">
          <div class="text-success" v-if="+item.is_canceled === 0">
            <f-awesome icon="clock"></f-awesome> В списке
          </div>
          <div class="text-canceled" v-if="+item.is_canceled === 1">
            <f-awesome icon="times"></f-awesome> Отменен
          </div>
        </div>
        <div v-if="item.clients && +item.is_canceled === 0" class="set-cancel mrg-r-5">
          <div @click="setCancel(index)" class="btn btn-sm btn-purple">Отменить</div>
        </div>
        <div v-if="item.clients && +item.is_canceled === 1" class="set-active mrg-r-5">
          <div @click="setActive(index)" class="btn btn-sm btn-success">Вернуть</div>
        </div>
        <div class="delete">
          <div @click="removeFromData(index)" class="btn btn-sm btn-danger">Удалить</div>
        </div>
      </div>

    </div>

    <!-- Добавление клиента в групповую запись -->
    <div v-if="allowMoreClient" class="text-center mrg-t-15">
      <div @click="plusClient" class="btn btn-sm btn-outline-info">
        <f-awesome icon="plus"></f-awesome> Клиент
      </div>
    </div>
    
    <!--      Редактирование клиента-->
    <popup
        :closeButton="infoClientPopup.closeButton"
        :show="infoClientPopup.show"
        @closePopup="closeInfoClientPopup"
    >
      <div slot="header">Клиент</div>
      <div slot="body">
        <info-client
            :show="infoClientPopup.show"
            :id="infoClientId"
            :no-delete="true"
            @updateClient="updateClient"
        ></info-client>
      </div>
    </popup>

    <popup
      :closeButton="notificationHistoryPopup.closeButton"
      :show="notificationHistoryPopup.show"
      @closePopup="closeNotificationHistoryPopup"
    >
      <div slot="header">История уведомлений</div>
      <div slot="body">
        <div class="text-center mrg-t-15 text-orange" v-if="notificationHistoryData.length === 0">
          История уведомлений отсутствует
        </div>
        <div v-if="notificationHistoryData.length > 0">
          <div class="table--container">
            <div class="table--header">
              <div class="name">Событие</div>
              <div class="datetime">Дата - время</div>
            </div>
            <div class="table--rows">
              <div class="table--row" v-for="item in notificationHistoryData" :key="item.id">
                <div 
                  class="name" 
                  :class="{'text-success': item.status == 1, 'text-danger': item.status == -1}"
                >
                  {{item.notif_type}} ({{ item.notif_method }})
                </div>
                <div class="text">{{datetimeToRus(item.send_dt)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </popup>


  </div>
</template>

<script>
//import VueMultiselect from "vue-multiselect";
import Popup from '../../../Popup.vue';
import InfoClient from '../../clients/InfoClient.vue';
import SearchClient from '../../clients/SearchClient.vue';
import Formatter from "../../../libraries/Formatter";
import ClientSelectModification from '../../clients/ClientSelectModification.vue';

const formatter = new Formatter();

export default {
  name: "FastClientsGroup",
  components: {SearchClient, Popup, InfoClient, ClientSelectModification},
  data() {
    return {
      data: [],
      infoClientPopup: {
        show: false,
        closeButton: "Закрыть"
      },
      notificationHistoryPopup: {
        show: false,
        closeButton: "Закрыть"
      },
      selectedNotificationHistoryIdx: 0,
      infoClientId: null,
    };
  },
  props: {
    enrollClients: Array,
    fullConfig: Object,
    is_group: Number,
    groupSetting: Object,
    reset: Number
  },
  watch: {
    enrollClients: function(val){
      if(val.length > 0){
        this.data = [];
        for(let key in val){
          let row = val[key];
          row.is_double = false;
          // row.send_sms_client = false;
          // row.send_whatsapp_client = false;
          // row.send_email_client = false;
          // row.send_telegram_client = false;
          this.$set(this.data, this.data.length, row);
          //this.data[this.data.length] = row;
        }
      }else{
        this.data = [];
        this.$set(this.data, this.data.length, this.getEmptyRow());
        //this.data[this.data.length] = this.getEmptyRow();
      }
    },
    data: {
      handler(val) {
        // Проверим на дубли
        for(let key in val){
          for(let key2 in val){
            if(
              key !== key2 && 
              val[key].clients && 
              val[key2].clients && 
              val[key].clients.number === val[key2].clients.number && 
              !val[key].is_double && !val[key2].is_double
            ){
              val[key2].is_double = true;
            }
          }
        }
        // Уберем дубли, если их исправили
        for(let key in val){
          if(val[key].is_double){
            let existsDouble = false;
            for(let key2 in val){
              if(
                key !== key2 && 
                val[key].clients.number === val[key2].clients.number
              ){
                existsDouble = true;
              }
            }
            if(!existsDouble){
              val[key].is_double = false;
            }
          }
        }
        this.$emit("input", val);
      },
      deep: true
    },
    // data: function(){
    //   console.log('edit');
    // }
  },
  computed: {
    notificationHistoryData(){
      let result = [];
      if(this.data.length){
        if(
          this.data[this.selectedNotificationHistoryIdx] && 
          this.data[this.selectedNotificationHistoryIdx].notifications_history && 
          this.data[this.selectedNotificationHistoryIdx].notifications_history.length
        ){
          result = this.data[this.selectedNotificationHistoryIdx].notifications_history;
        }
      }
      return result;
    },
    clientActiveCount(){
      let clientCount = 0;
      if(this.groupSetting && +this.is_group === 1){
        for(let key in this.data){
          if(+this.data[key].is_canceled === 0){
            if(this.data[key].clients){
              clientCount++;
            }
          }
        }
      }
      return clientCount;
    },
    allowMoreClient(){
      let result = false;
      let clientCount = 0;
      if(this.groupSetting && +this.is_group === 1){
        for(let key in this.data){
          if(+this.data[key].is_canceled === 0){
            if(this.data[key].clients){
              clientCount++;
            }else{
              return false;
            }
          }
        }
        if(this.groupSetting.participants_count > clientCount){
          result = true;
        }
      }
      return result;
    }
  },
  methods: {
    datetimeToRus(datetime){
      return formatter.phpDateTimeToShortString(datetime);
    },
    showNotificationHistoryPopup(idx){
      this.selectedNotificationHistoryIdx = idx;
      this.notificationHistoryPopup.show = true;
    },
    closeNotificationHistoryPopup(){
      this.notificationHistoryPopup.show = false;
    },
    setActive(idx){
      // Проверим. Если кол-во активных >= кол-во мест, то запретим вернуть, 
      // выдав соответствующее предупреждение
      if(this.groupSetting.participants_count <= this.clientActiveCount){
        this.$store.dispatch("addNotification", {
          text: 'Больше нет мест в групповой записи. Увеличьте кол-во участников',
          time: 3,
          color: "danger"
        });
        return false;
      }
      this.$set(this.data[idx], 'is_canceled', 0);
      this.$set(this.data[idx], 'cancel_reason', '');
    },
    setCancel(idx){
      this.$set(this.data[idx], 'is_canceled', 1);
    },
    removeFromData(idx){
      this.data.splice(idx, 1);
    },
    plusClient(){
      this.$set(this.data, this.data.length, this.getEmptyRow());
    },
    updateClient(val){
      for(let key in this.data){
        if(+this.data[key].clients.id === +val.id){
          this.data[key].clients = val;
        }
      }
    },
    showInfoClientPopup(client_id){
      this.infoClientId = +client_id;
      this.infoClientPopup.show = true;
    },
    closeInfoClientPopup() {
      this.infoClientPopup.show = false;
    },
    
    getEmptyRow(){
      return {
            add_field: '',
            client_modification_id: 0,
            comment: '',
            is_canceled: '0',
            cancel_reason: '',
            // send_sms_client: false,
            // send_whatsapp_client: false,
            // send_email_client: false,
            // send_telegram_client: false,
            is_double: false, 
            clients: null
          };
    },
    whatsAppEndpoint(phone){
      return 'https://wa.clck.bar/' +phone;
    },
    clickManualSms(number){
      this.$emit('clickManualSms', number);
    },
    copyText(text){
      navigator.clipboard.writeText('+' +text)
          .then(() => {
            this.$store.dispatch("addNotification", {
              text: 'Номер скопирован в буфер обмена',
              time: 3,
              color: "success"
            });
          })
          .catch(() => {
            this.$store.dispatch("addNotification", {
              text: 'Ваш браузер не поддерживает копирование',
              time: 3,
              color: "danger"
            });
          });
    },
  },
  created() {}
};
</script>

<style scoped lang="less">
.fast-clients--container{
  padding-top: 1px;
  margin-top: 8px;

  .fast-clients--row{
    border-bottom: 1px solid #333;
    padding-bottom: 30px;

    .fast-clients--status{
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;
      flex-direction: row;

      .status{
        line-height: 2.05;
      }
    }
  }

  .client-line--flex{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;

    &>div{
      margin-top: 8px;
    }
  }
}

.new-fast--addfield-line{
  box-sizing: border-box;

  .text{
    padding: 4px 4px 4px 8px;
    border-left: 2px solid #F97979;
    font-style: italic;
  }

  // .title{
  //   font-size: 15px;
  //   font-weight: 700;
  // }
}
.new-fast--comments-line{
  .title{
    color: #333;
  }
  .new-fast--comment-client{
    border-left: 2px solid #F97979;
    padding: 5px 4px 5px 8px;
    box-sizing: border-box;

    .text{
      font-style: italic;
      //margin-top: 8px;
    }
  }
}

@media (max-width: 600px) {
  
}
</style>
